import { z } from 'zod';

export const jwtSchema = z.object({
  access_token: z.string().min(1),
  expires_in: z.number().min(1),
  refresh_token: z.string().min(1),
  scope: z.literal('offline_access'),
  token_type: z.literal('Bearer'),
});

export type jwt = z.infer<typeof jwtSchema>;
